/* @jsx h */
import { defineComponent, h, onMounted } from "vue";
import { RouterView } from "vue-router";
import { setTitle } from "@lemmonhq/orders";

export { WeeklyHeatmapPage } from "./subpages/WeeklyHeatmap/index";
export { RevenuePage } from "./subpages/Revenue";
export { OverviewPage } from "./subpages/Overview";
export { TipsSummaryPage } from "./subpages/Tips";
export { ClosingReportsPage } from "./subpages/ClosingReports";
export { DataExportPage } from "./subpages/DataExport";
export { ShiftsReportPage } from "./subpages/ShiftsReport";
export { DataDetailPage } from "./subpages/DataDetail";
export { ChartOfAccountsPage } from "./subpages/ChartOfAccounts/index";
export { DataRoomPage } from "./subpages/DataRoom/index";
export { ReservationsReportPage } from "./subpages/Reservations/index";
export { LiveStatusPage } from "./subpages/LiveStatus/index";
import { PageComponent, useLocalization } from "@lemmonhq/uikit";

import { useAuth } from "@app/vue/providers/index";

export const ReportsPage = defineComponent({
  name: "ReportsPage",
  props: ["children"],
  setup(props) {
    onMounted(() => {
      setTitle("Reports");
    });

    const auth = useAuth();

    const { t } = useLocalization();
    return () => {
      const isManager = auth.user.value?.role === "manager";
      const isStaging = import.meta.env.VITE_ENV === "staging";

      const subpages = [
        // Live sits first and outside the manager gate on purpose: it is the
        // floor's page, it exposes no historical or per-staff financials, and
        // during service it is the one anybody opens first.
        {
          name: t("reports.nav.live"),
          icon: "bolt",
          href: "/app/reports/live",
        },
        {
          name: t("reports.nav.sales_dashboard"),
          icon: "show_chart",
          href: "/app/reports",
        },
        {
          name: t("reports.nav.payment_history"),
          icon: "history",
          href: "/app/reports/transactions",
        },
        {
          name: t("reports.nav.tips"),
          icon: "savings",
          href: "/app/reports/tips",
        },
        {
          name: t("reports.nav.closing_reports"),
          icon: "sunny",
          href: "/app/reports/closing_reports",
        },
        ...(isManager
          ? [
              {
                name: t("reports.nav.revenue"),
                icon: "stacked_line_chart",
                href: "/app/reports/revenue",
              },
              {
                name: t("reports.nav.shifts"),
                icon: "person",
                href: "/app/reports/shifts",
              },
              {
                name: t("reports.nav.weekly_sales"),
                icon: "date_range",
                href: "/app/reports/weekly_heatmap",
              },
              {
                name: t("reports.nav.reservations"),
                icon: "event_available",
                href: "/app/reports/reservations",
              },
              {
                name: t("reports.nav.dataroom"),
                icon: "database",
                href: "/app/reports/dataroom",
              },
              ...(isStaging
                ? [
                    {
                      name: t("reports.nav.chart_of_accounts"),
                      icon: "account_tree",
                      href: "/app/reports/chart_of_accounts",
                    },
                  ]
                : []),
              {
                name: t("reports.nav.export"),
                icon: "file_export",
                href: "/app/reports/export",
              },
            ]
          : [
              {
                name: t("reports.nav.shifts"),
                icon: "person",
                href: "/app/reports/shifts",
              },
            ]),
      ];
      return (
        <PageComponent
          title="Reports"
          titleIcon="monitoring"
          subpages={subpages}
        >
          <RouterView />
        </PageComponent>
      );
    };
  },
});
